import FacilityTypeForm from "./FacilityTypeForm";

export default FacilityTypeForm